<template>
  <div>
    <b-row>
      <b-col cols="6" v-if="viewAs !== 'employee'">
        <b-card @click="showModal('Unassigned', statistics?.unassigned)" class="full-width cursor-pointer">
          <b-card-title>Unassigned</b-card-title>
          <b-card-text class="text-center font-weight-bold text-lg-center">
            <h1>{{  statistics?.unassigned || 0 }}</h1>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="6" v-else>
        <b-card @click="showModal('Not Started', statistics?.not_started)" class="full-width cursor-pointer">
          <b-card-title>Not Started</b-card-title>
          <b-card-text class="text-center font-weight-bold text-lg-center">
            <h1>{{ statistics?.not_started || 0 }}</h1>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="6">
        <b-card @click="showModal('Overdue', statistics?.overdue)" class="full-width cursor-pointer">
          <b-card-title>Overdue</b-card-title>
          <b-card-text class="text-center font-weight-bold text-lg-center">
            <h1>{{ statistics?.overdue || 0 }}</h1>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="6">
        <b-card @click="showModal('In Progress', statistics?.in_progress)" class="full-width cursor-pointer">
          <b-card-title>In Progress</b-card-title>
          <b-card-text class="text-center font-weight-bold text-lg-center">
            <h1>{{  statistics?.in_progress || 0 }}</h1>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="6">
        <b-card @click="showModal('Completed', statistics?.completed)" class="full-width cursor-pointer">
          <b-card-title>Completed</b-card-title>
          <b-card-text class="text-center font-weight-bold text-lg-center">
            <h1>{{  statistics?.completed || 0 }}</h1>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
        id="modal-view"
        centered
        :title="type"
        hide-footer
        size="lg"
        no-close-on-backdrop
        @hidden="hiddenModal"
    >
      <b-row>
        <b-col cols="6">
          <div class="d-flex align-items-center h-100 justify-content-center">
            <h1 class="font-large-1"> {{ value || 0 }} </h1>
          </div>
        </b-col>
        <b-col cols="6">
          <DataTable :endpoint="endpoint" :isSubtask="isSubtask" />
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner, BTab, BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'

import LvColorPicker from 'lightvue/color-picker'
import { milestoneTaskBoardStatusConstants } from '@/helpers/constant/milestoneTaskBoardStatusConstant.js'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import flatPickr from 'vue-flatpickr-component'
import {
  milestoneBoardTypeConstants as milestoneBoardTypeConstant,
} from '@/helpers/constant/milestoneBoardTypeConstant.js'
import UserSelect from '@/layouts/components/UserSelect.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import { formatDateRange } from '@/helpers/helpers'
import {
  required, max, size, ext, max_value, min_value,
} from '@validations'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import BCardCode from '@core/components/b-card-code'
import DashboardActivityLog from '@/views/admin/task-management/Dashboard/Component/DashboardActivityLog.vue'
import TodayAssignedTable from '@/views/admin/task-management/Dashboard/Component/TodayAssignedTable.vue'
import WeeklyDueTasks from '@/views/admin/task-management/Dashboard/Component/WeeklyDueTasksTable.vue'
import DataTable from '@/views/admin/task-management/Dashboard/Component/DataTable.vue'

export default {
  name: 'DashboardStatisticsView',
  components: {
    DataTable,
    WeeklyDueTasks,
    TodayAssignedTable,
    DashboardActivityLog,
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    isSubtask: {
      type: Boolean,
      default: true
    },
    viewAs: {
      type: String,
      default: 'employee',
    }
  },
  watch: {
    isSubtask: {
      immediate: true,
      handler(newVal) {
        this.loadItems()
      }
    },
  },
  data() {
    return {
      statistics: [],
      type: null,
      value: '',
      endpoint: ''
    }
  },

  async created() {
    try {
      await this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'BellIcon',
          variant: 'danger',
          text: error?.response?.data?.message,
        },
      })
    }
  },

  methods: {

    hiddenModal() {
      this.$bvModal.hide('modal-view')
    },

    showModal(type = '', data = '') {
      this.type = type
      this.value = data

      let endpoint = `api/${this.isSubtask ? 'subtasks' : 'tasks'}-dashboard/statistic-tasks/`

      switch (type) {
        case 'Unassigned':
          endpoint += 'unassigned'
          break
        case 'Overdue':
          endpoint += 'overdue'
          break
        case 'In Progress':
          endpoint += 'in_progress'
          break
        case 'Not Started':
          endpoint += 'not_started'
          break
        default:
          endpoint += 'completed'
      }

      endpoint += `?view=${this.viewAs}`;

      this.endpoint = endpoint + '&include=phase,milestoneTaskBoard.department,milestoneTaskBoard.supervisor,team,task'

      this.$bvModal.show('modal-view')
    },

    async loadItems() {
      try {

        const statistics = await this.$api.get(
          `api/${this.isSubtask ? 'subtasks' : 'tasks'}-dashboard/statistics?view=${this.viewAs}`,
)

        this.statistics = statistics?.data

      } catch (error) {
        const message =
            error?.response?.data?.message ||
            error.message ||
            'Failed to load members';

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: message,
          },
        });
      }
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}
</style>
